// Action creators
import { readJson } from './apiResponse';

// http://localhost:60452/api/OnCallSchedule/UpsertCurrentSchedule
// http://localhost:60452/api/OnCallSchedule/List
// http://localhost:60452/api/OnCallSchedule/GetMostRecentSchedule 
// http://localhost:60452/api/OnCallSchedule/GetAllRecentSchedules

var getScheduleFetch = () => {
  return function (dispatch) {
    const token = localStorage.token;
    if (!token) {
      return Promise.resolve();
    }

    return fetch('api/OnCallSchedule/GetAllRecentSchedules', {
      method: "GET",
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(results => readJson(results, 'api/OnCallSchedule/GetAllRecentSchedules'))
      .then(json => {
        if (!json) {
          return;
        }
        dispatch({ type: 'LOAD_SCHEDULE', payload: json });
      })
      .catch(err => console.error('getScheduleFetch failed:', err));
  };
}

var toggleUser = (userId, company) => {
  return function (dispatch) {
    dispatch({ type: "TOGGLE_EMAIL_LIST_USER", payload: { 'userId': userId, 'company': company } });
  };
}


// what data needs to be posted? {id: "", scheduleId: "", beginTime: "", endTime: "", prime: "", secondary: "", tertiary: ""}

var updateSchedule = (company, schedule) => {
  return function (dispatch) {
    const token = localStorage.token;
    if (!token) {
      return Promise.resolve();
    }

    return fetch("api/OnCallSchedule/UpsertCurrentSchedule", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ 'Company': company, 'LineItems': schedule['onCallLineItems']})
    })
      // This used to hand back the bare fetch, so a refused or failed save
      // was silent: nothing read the status and nothing caught the
      // rejection. The caller ignores the result, so a failure can only be
      // reported here.
      .then(response => readJson(response, 'api/OnCallSchedule/UpsertCurrentSchedule'))
      .then(json => json || null)
      .catch(err => {
        console.error('updateSchedule failed:', err);
        return null;
      });
  }
}

var sendEmail = (company, schedule) => {
  return function (dispatch, getState) {
    // The recipients come from the store, not from the schedule passed in.
    // OnCallScheduleList passes its own state copy, taken when the company
    // was picked; ticks go through TOGGLE_EMAIL_LIST_USER, which now replaces
    // the schedule rather than mutating it, so that copy no longer sees them.
    // The store is what the checkboxes render from.
    var stored = getState ? (getState().schedule || []).filter(s => s['company'] === company)[0] : undefined;
    var checkedUserIds = (stored && stored['checkedUserIds']) || schedule['checkedUserIds'] || [];
    var l = [];
    for (var i = 0; i < checkedUserIds.length; i++) {
      var onCallLineItem = checkedUserIds[i];
      l.push({ 'EmailRecipient': onCallLineItem });
    }
    const token = localStorage.token;
    if (!token) {
      return Promise.resolve();
    }

    return fetch("api/OnCallEmailList/SendEmail", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ 'Company': company, 'LineItems': l, 'ScheduleId': schedule.id })
    })
      // SendEmail answers a bare true or false. A false - the mail did not
      // go - used to be as invisible as a network failure, because the raw
      // fetch was returned and nobody looked at it.
      .then(response => readJson(response, 'api/OnCallEmailList/SendEmail'))
      .then(sent => {
        if (sent === null) {
          return null;
        }
        if (sent !== true) {
          console.error('api/OnCallEmailList/SendEmail did not send:', sent);
        }
        return sent;
      })
      .catch(err => {
        console.error('sendEmail failed:', err);
        return null;
      });
  }
}

export default { 'LOAD_SCHEDULE': getScheduleFetch, 'SEND_EMAIL': sendEmail, 'TOGGLE_USER': toggleUser, 'UPDATE_SCHEDULE': updateSchedule };


// WEBPACK FOOTER //
// ./src/actions/schedule_actions.js